import BlAnnouncementMv from './BlAnnouncementMv.vue'

BlAnnouncementMv.install = function(Vue) {
  Vue.component(BlAnnouncementMv.name, BlAnnouncementMv)
}

export default BlAnnouncementMv
